import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      listItem: {
        marginBlock: tokens.spacingGap100,
      },

      title: {
        textTransform: 'uppercase',
        marginBlockStart: tokens.spacingGap150,
        marginBlockEnd: tokens.spacingGap100,
      },
    },
  } as const
}
